export const advancedActions = "drc";
export const customizeActions = "erc";
export const emojiTooltip = "frc";
export const itemHeaderLike = "grc";
export const itemHeaderReplyByMeeting = "hrc";
export const itemHeaderDelete = "irc";
export const itemHeaderAddToSafeSenders = "jrc";
export const itemHeaderMarkAsPhishing = "krc";
export const itemHeaderViewMessageSource = "lrc";
export const itemHeaderDownload = "mrc";
export const itemHeaderViewMessageDetails = "nrc";
export const messageSafety = "orc";
export const none = "prc";
export const otherAddins = "qrc";
export const otherReplyActions = "rrc";
export const proofingSettings = "src";
export const quickUseLabel = "trc";
export const readUnread = "urc";
export const replyByImSurfaceActionLabel = "vrc";
export const replyAllByImSurfaceActionLabel = "wrc";
export const setDictationLanguage = "xrc";
export const toggleDarkCompose = "yrc";
export const toggleDictationToolTip = "zrc";
export const viewActions = "Arc";
export const createFluidDocument = "Brc";
export const setReaction = "Crc";
export const forwardEmailAsAttachment = "Drc";
export const findTimeTooltip = "Erc";
export default {advancedActions,customizeActions,emojiTooltip,itemHeaderLike,itemHeaderReplyByMeeting,itemHeaderDelete,itemHeaderAddToSafeSenders,itemHeaderMarkAsPhishing,itemHeaderViewMessageSource,itemHeaderDownload,itemHeaderViewMessageDetails,messageSafety,none,otherAddins,otherReplyActions,proofingSettings,quickUseLabel,readUnread,replyByImSurfaceActionLabel,replyAllByImSurfaceActionLabel,setDictationLanguage,toggleDarkCompose,toggleDictationToolTip,viewActions,createFluidDocument,setReaction,forwardEmailAsAttachment,findTimeTooltip};